import { FC, PropsWithChildren } from "react";
import styles from "./style.module.css";

interface ComponentProps extends PropsWithChildren {
  bg: string;
}

const IconContainer: FC<ComponentProps> = ({ children, bg }) => {
  return (
    <div className={styles.container} style={{ backgroundColor: bg }}>
      {children}
    </div>
  );
};

export default IconContainer;
